import { useCallback } from 'react';
import { useChatStore, getChatByParticipantId } from '@entities/messanger';

export const useChatList = () => {
  const chats = useChatStore((state) => state.chats);
  const selectedChat = useChatStore((state) => state.selectedChat);
  const selectChat = useChatStore((state) => state.selectChat);

  const handleSelectChat = useCallback(
    (chat) => {
      selectChat(chat);
    },
    [selectChat]
  );

  const findChatByUserId = useCallback(
    (userId) => getChatByParticipantId(chats, userId),
    [chats]
  );

  return {
    chats,
    selectedChat,
    handleSelectChat,
    findChatByUserId,
  };
};
